import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { Card, Col, Row, FormFeedback } from 'reactstrap'
import { IconTrash } from '@tabler/icons-react'
// @ts-ignore
import { Avatar, Button } from 'dsm-react-lib'
import DataTable, { createTheme } from 'react-data-table-component'

// Register a theme-aware DataTable theme using CSS variables.
// This overrides the library's hardcoded #FFFFFF backgrounds at the source,
// ensuring all StyledDataTable instances respect light/dark mode.
createTheme('themed', {
  background: {
    default: 'var(--surface-bg)'
  },
  text: {
    primary: 'var(--text-heading)',
    secondary: 'var(--text-subheading)',
    disabled: 'var(--text-subheading)'
  },
  divider: {
    default: 'var(--theme-border)'
  },
  button: {
    default: 'var(--text-subheading)',
    hover: 'var(--item-hover-bg)',
    focus: 'var(--item-hover-bg)',
    disabled: 'var(--text-subheading)'
  },
  sortFocus: {
    default: 'var(--text-subheading)'
  },
  highlightOnHover: {
    default: 'var(--item-hover-bg)',
    text: 'var(--text-heading)'
  },
  striped: {
    default: 'var(--surface-muted)',
    text: 'var(--text-heading)'
  },
  selected: {
    default: 'var(--selected-bg)',
    text: 'var(--text-heading)'
  },
  context: {
    background: 'var(--surface-muted)',
    text: 'var(--text-heading)'
  }
})

export const ProfileIconLayout = styled.div`
  background: var(--color-primary-dark);
  border-radius: 10px;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: white;
`

export const PreviewIconLayout = styled.div`
  background: var(--color-primary-dark);
  border-radius: 15% !important;
  width: 142px;
  height: 142px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: white;
`

export const ProfileIcon = styled(Avatar)`
  border-radius: 10px;
  border: 1px solid var(--theme-border) !important;
  background-color: var(--surface-muted) !important;

  *,
  & > div {
    border-color: var(--theme-border) !important;
  }
`

export const HiddenInput = styled.input`
  display: none;
`

export const Preview = styled(Row)`
  position: relative;
  display: grid;
  grid-template-columns: 160px auto;
  gap: 2rem;
  align-items: center;
`

export const Image = styled.img`
  width: 150px;
  height: 85px;
  margin: 1rem 1rem 0 0;
  border: 1px solid var(--border-strong) !important;
`

export const PreviewContainer = styled(Card)`
  padding: 1rem;
  shadow: none;
  height: 300px;
  border: 0;

  /* Remove white border from DSM Avatar in preview */
  div[class*='avatar'],
  div[class*='Avatar'],
  .dsm-avatar {
    border: none !important;
    box-shadow: none !important;

    * {
      border: none !important;
    }
  }
`

export const CrossBtn = styled(Button)`
  left: 145px;
  position: absolute;
  margin: 1rem 1rem 0 0 !important;
  padding: 0.2rem !important;
  z-index: 999;
  width: 20px;
  height: 22px;
`

export const ActionBtn = styled(Button)`
  box-shadow: 0px 4px 6px rgba(75, 75, 75, 0.12);
  border-radius: 50% !important;
  padding: 0.715rem 0.736rem;

  &[color='primary'] {
    color: var(--brand-accent-color) !important;
    svg {
      color: var(--brand-accent-color) !important;
      stroke: var(--brand-accent-color) !important;
    }
  }
`

export const StyledCol = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Title = styled.span`
  color: var(--color-primary);
  font-size: 2.5rem;
`

export const StyledText = styled.div`
  font-size: 1.2rem;
`

export const PrimaryText = styled.div`
  font-size: 1.2rem;
  padding: 2rem 0 1rem 0;
  color: var(--color-primary);
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  text-align: center;
  padding-top: 2rem;
`

export const AppName = styled.div`
  margin-left: 0.5rem;
  &:hover {
    text-decoration: underline;
  }
`

export const Feedback = styled(FormFeedback)`
  width: auto;
  display: block;
  margin-left: 1rem;
`

export const StatusContainer = styled.div`
  width: 200px;
  margin-left: 1rem;
`
export const FileIcon = styled.img`
  width: 30px;
  height: 24px;
  margin-right: 1rem;
  border-radius: 5px;
`

export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: -webkit-fill-available;
  padding: 0.5rem;
`

export const DeleteIcon = styled(IconTrash)`
  color: var(--color-danger);
  margin-left: 1rem;
  padding: 0;
  cursor: pointer;
`

export const ApplicationDataWrapper = styled(Row)`
  display: ${(props) => (props.$activeItemId ? '' : 'none')};
`
export const DropdownOption = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  align-items: center;

  :active {
    color: white;
    stroke: white;
  }
`
export const StyledIcon = styled(Avatar)`
  margin: 1rem;
  padding: 0.2rem;
  border: 1px solid var(--theme-border) !important;

  *,
  & > div {
    border-color: var(--theme-border) !important;
    background-color: transparent !important;
  }
`
// React 19 dropped defaultProps, so pagination defaults are restored here to avoid
// an infinite re-render loop when `data` loads async (see react19-migration-gotchas memory).
export const StyledDataTable = styled(DataTable).attrs((props: any) => ({
  theme: typeof props.theme === 'string' ? props.theme : 'themed',
  paginationServerOptions: props.paginationServerOptions ?? {
    persistSelectedOnPageChange: false,
    persistSelectedOnSort: false
  },
  paginationDefaultPage: props.paginationDefaultPage ?? 1,
  paginationRowsPerPageOptions: props.paginationRowsPerPageOptions ?? [10, 15, 20, 25, 30]
}))`
  .rdt_TableHead,
  .rdt_TableHeadRow,
  .rdt_TableHead .rdt_TableCol,
  .rdt_TableHead .rdt_TableCol_Sortable {
    border: none !important;
    box-shadow: none !important;
  }

  .rdt_TableBody {
    overflow-x: auto;
    min-height: ${(props: any) => (props?.disableMinHeight ? '0px' : '300px')};
  }

  .rdt_Pagination {
    position: sticky;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  .rdt_TableCol_Sortable {
    svg {
      display: inline-block !important;
      opacity: 0;
      transition: opacity 0.15s ease;
    }

    &:hover svg {
      opacity: 1;
    }
  }

  .rdt_TableCol_Sortable[aria-sort='ascending'],
  .rdt_TableCol_Sortable[aria-sort='descending'] {
    svg {
      opacity: 1 !important;
    }
  }

  /* Lets a column-header resize handle (rendered inside the column's name node) sit at the
     true right edge of the header cell, instead of hugging the label text - the handle
     positions itself relative to .rdt_TableCol rather than whatever inner wrapper the
     library renders the name/sort-icon in. Scoped to .has-resizable-columns so other
     StyledDataTable instances are unaffected. */
  &.has-resizable-columns .rdt_TableCol {
    position: relative;
    overflow: visible;
  }
`
